module.exports = __webpack_public_path__ + "img/Flag_of_Hungary.c89f36c8.svg";